export const API_KEY = process.env.REACT_APP_TMDB_API_KEY || '5f5c3fe7d8050abeb782fc995a4611da';
export const BASE_URL = 'https://api.themoviedb.org/3';
export const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p';
export const LANGUAGE = 'ru';

export const API_ENDPOINTS = {
  NOW_PLAYING: `${BASE_URL}/movie/now_playing`,
  POPULAR: `${BASE_URL}/movie/popular`,
  TOP_RATED: `${BASE_URL}/movie/top_rated`,
  SEARCH: `${BASE_URL}/search/multi`,
  MOVIE_DETAILS: (id) => `${BASE_URL}/movie/${id}`,
  MOVIE_VIDEOS: (id) => `${BASE_URL}/movie/${id}/videos`,
  MOVIE_RECOMMENDATIONS: (id) => `${BASE_URL}/movie/${id}/recommendations`,
  MOVIE_CREDITS: (id) => `${BASE_URL}/movie/${id}/credits`,
  GENRES: `${BASE_URL}/genre/movie/list`,
  MOVIES_BY_GENRE: (genreId) => `${BASE_URL}/discover/movie?with_genres=${genreId}`,
  // TV Shows
  TV_POPULAR: `${BASE_URL}/tv/popular`,
  TV_TOP_RATED: `${BASE_URL}/tv/top_rated`,
  TV_AIRING_TODAY: `${BASE_URL}/tv/airing_today`,
  // Animated movies (genre id 16)
  ANIMATED_MOVIES: `${BASE_URL}/discover/movie?with_genres=16`,
};

